import React, { useEffect, useState } from 'react'
import DynamicForm from './Dynamic_Form_parent/DynamicForm';
import ErrorBoundary from './Dynamic_Form_parent/DynamicForm/ErrorBoundary';
import { formService } from '@/services';

export const Form = () => {
    const [formData, setFormData] = useState();

    useEffect(() => {
      const getData = async () => {
        try {
          const data = await formService.getForm(1);
          setFormData(data.data);
        }
        catch (err) {
          alert("Failed to retrieve data");
        }
      }
  
      getData();
    }, []);
  
    if (!formData) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F1EBDB]">
          <div className="text-center">
            {/* <h3 className="text-lg font-medium text-gray-900">No form data found</h3>
            <p className="mt-1 text-sm text-gray-500">Please try refreshing the page.</p> */}
          </div>
        </div>
      );
    }
    
    return (
      <ErrorBoundary>
        <DynamicForm formData={formData} />
      </ErrorBoundary>
    );
  }
  
